import * as React from "react";
const SvgIconHilight = props => <svg xmlns="http://www.w3.org/2000/svg" width={4} height={45} fill="none" viewBox="0 0 4 45" {...props}><path fill="#9747FF" d="M0 45V0a4 4 0 0 1 4 4v37a4 4 0 0 1-4 4" /></svg>;
export default SvgIconHilight;